"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchRequirementType = void 0;
/**
 * The requirement needed to trigger a branch in a chart with diverge notes.
 */
class BranchRequirementType {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        if (id === 'r') {
            return BranchRequirementType.Drumroll;
        }
        return BranchRequirementType.Accuracy;
    }
    static fromRaw(raw, strict = true) {
        return BranchRequirementType.fromId(raw, strict);
    }
    toString() {
        return this._id;
    }
}
exports.BranchRequirementType = BranchRequirementType;
/*
  The amount of drumroll and balloon hits determines the path. In TJA, this
  type is represented by the letter `r`.
*/
BranchRequirementType.Drumroll = new BranchRequirementType('r');
/*
  Accuracy determines the path. Note accuracy between #SECTION and one
  measure before #BRANCHSTART are summed together, divided by their amount,
  and multiplied by 100 (exception: zero amount of notes will equal zero
  accuracy). GOOD notes have 1 accuracy, OK notes have 0.5 accuracy, and BAD
  notes have 0 accuracy. In TJA, this type is represented by the letter `p`,
  but any other value will trigger this type.
*/
BranchRequirementType.Accuracy = new BranchRequirementType('p');
BranchRequirementType._values = [
    BranchRequirementType.Drumroll,
    BranchRequirementType.Accuracy,
];
